export const ROLE_DYNAMIC_GALLERY = 'dynamic-gallery';

export const DYNAMIC_GALLERY_ROLES = [ROLE_DYNAMIC_GALLERY];
